import { useMemo } from 'react'
import { map } from 'lodash'

import { sectionsMap } from '@/components/sections'

import { WPPageData } from '@/types'

export type BuilderProps = {
  pageProps?: WPPageData
}

const Builder = ({ pageProps }: BuilderProps) => {
  const builder = useMemo(() => pageProps?.acf?.builder || [], [pageProps])

  let nonSpacerCount = 0

  return map(builder, ({ acf_fc_layout, ...section }, index) => {
    const Component = sectionsMap[acf_fc_layout]
    const isExcludedFromCount = acf_fc_layout === 'spacer' || acf_fc_layout === 'tape'
    const isFirst = !isExcludedFromCount && nonSpacerCount === 0
    if (!isExcludedFromCount) nonSpacerCount++
    return Component ? (
      <Component
        data-layout={acf_fc_layout}
        key={`${acf_fc_layout}-${index}`}
        is_first={isFirst}
        {...section}
      />
    ) : null
  })
}

export default Builder
